import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import Button from 'components/button/button';
import Endpoints from 'helpers/enums/endpoints';
import Hero from 'components/heroes/hero';
import MakeHash from 'make-hash';
import Page from 'components/page/page';
import Text from 'components/text/text';
import TextField from 'components/fields/text-field';
import TransitionLink from 'components/transition-link/transition-link';
import messages from './messages';
import { gigyaPasswordReset } from './gigya.js';
import { loadScriptAsync } from './gigya';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        const { intl } = props;

        this.state = {
            serverError: false,
            formMessages: [],
            loading: false,
        };
        this.page = {
            heading: intl.formatMessage(messages.forgot_password_heading),
            intro: intl.formatMessage(messages.forgot_password_intro),
        };
        this.primaryAction = {
            label: intl.formatMessage(messages.submit_label),
        };
        this.secondaryAction = {
            path: '/sign-in',
            label: intl.formatMessage(messages.cancel_label),
        };
        this.fields = {};

        this.setUpHandlers();
    }

    /**
     * Binds any handlers to the correct context
     *
     * @method  setUpHandlers
     */
    setUpHandlers() {
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleError = this.handleError.bind(this);
        this.trackField = this.trackField.bind(this);
    }

    trackField(field) {
        if (!field) return;

        this.fields[field.input.name] = field;
    }

    componentDidMount() {
        // Load gigya screen set if gigya env configured
        if (process.env.REACT_APP_AUTH_BACKEND === 'gigya') {
            loadScriptAsync(
                `https://cdns.gigya.com/js/gigya.js?apikey=${process.env.REACT_APP_GIGYA_KEY}`
            ).then(() => {
                gigyaPasswordReset();
            });
        }
    }

    /**
     * Handles submission of login form
     * Will validate email and password fields
     * based on their latest values
     *
     * @method  handleSubmit
     */
    handleSubmit(event) {
        if (event) event.preventDefault();

        if (this.formHasErrors()) return;

        this.setState({
            serverError: false,
            formMessages: [],
        });
        this.resetPassword();
    }

    formHasErrors() {
        const fields = Object.values(this.fields);

        const errors = fields.filter((f) => {
            return !f.isValid();
        });

        return errors.length > 0;
    }

    handleError(error) {
        error.response.json().then((resp) => {
            this.setState({
                loading: false,
                serverError: true,
                formMessages: [resp.reason],
            });
        });
    }

    /**
     * Send email link to user to reset password.
     *
     * @method  resetPassword
     */
    resetPassword() {
        const { intl } = this.props;
        const email = this.fields.email.input.value;

        this.setState({ loading: true });

        this.props.apiService
            .post(
                Endpoints.passwordReset,
                { email: email, client: 'rider' },
                this.handleError
            )
            .then((data) => {
                if (typeof data === 'undefined') return;
                this.setState({
                    loading: false,
                    serverError: false,
                    formMessages: [
                        intl.formatMessage(messages.reset_email_sent, {
                            email: email.trim(),
                        }),
                    ],
                });
            });
    }

    _renderHero() {
        return (
            <Hero title={this.page.heading} supportingTxt={this.page.intro} />
        );
    }

    _renderFormMessages() {
        const ulClasses = classNames('form-messages', {
            'form-messages_hasMessage': this.state.formMessages.length > 0,
        });
        const color = this.state.serverError ? 'DefaultOrange' : 'DefaultBlue';

        return (
            <ul className={ulClasses}>
                {this.state.formMessages.map((msg, i) => {
                    return (
                        <li key={MakeHash(`${msg}-${i}`)}>
                            <Text color={color} weight="light">
                                {msg.endsWith('.') ? msg : msg + '.'}
                            </Text>
                        </li>
                    );
                })}
            </ul>
        );
    }

    render() {
        const { intl } = this.props;
        const pageHero = this._renderHero();
        const formMessages = this._renderFormMessages();
        const className =
            process.env.REACT_APP_AUTH_BACKEND === 'gigya' ? 'hidden' : '';

        return (
            <Page title={this.page.heading} pageHero={pageHero}>
                <div className="container container_constrainedMd">
                    <div className="gigya-screen-set" id="userScreensDiv" />
                    <form
                        onSubmit={this.handleSubmit}
                        autoComplete="off"
                        noValidate
                        className={className}
                    >
                        {formMessages}
                        <div className="form-fields">
                            <div className="set">
                                <div className="set-hd">
                                    <TextField
                                        type="email"
                                        name="email"
                                        label={intl.formatMessage(
                                            messages.email_label
                                        )}
                                        errorMsg={intl.formatMessage(
                                            messages.email_format_error
                                        )}
                                        ref={this.trackField}
                                    />
                                </div>
                                <div className="set-bd set-bd_super">
                                    <div className="set mix-set_alignCenter">
                                        <div className="set-hd">
                                            <Button
                                                className="btn_fixedWidth"
                                                theme="dark"
                                                onClick={this.handleSubmit}
                                                type="submit"
                                            >
                                                {this.primaryAction.label}
                                            </Button>
                                        </div>
                                        <div className="set-bd set-bd_separated">
                                            <TransitionLink
                                                className="txt txt_reg mix-txt_colorDefaultBlue"
                                                to={this.secondaryAction.path}
                                            >
                                                {this.secondaryAction.label}
                                            </TransitionLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </Page>
        );
    }
}

export default injectIntl(ForgotPassword);



// WEBPACK FOOTER //
// ./src/client/pages/auth/forgot-password.jsx